import { useState } from "react";
import styles from "../AutomateTab/AutomateTab.module.css";
import AnimatedBtn from "../../AnimatedBtn/AnimatedBtn";
import StartNowBtn from "../../StartNowBtn/StartNowBtn";
import TitleBar from "../../TitleBar/TitleBar";
import { PortableText } from "@portabletext/react";
const AutomateTab = ({ rexptWorkFlow }) => {
  const ptComponents = {
    marks: {
      purple: ({ children }) => (
        <span style={{ color: "#6524EB" }}>{children}</span>
      ),
      strong: ({ children }) => <strong>{children}</strong>,
      break: ({ children }) => (
        <>
          {children}
          <br />
        </>
      ),
    },
    list: {
      bullet: ({ children }) => <ul className="list-disc ml-6">{children}</ul>,
      number: ({ children }) => (
        <ol className="list-decimal ml-6">{children}</ol>
      ),
    },
  };
  const isVideoUrl = (url = "") => /\.(mp4|webm|ogg)(\?|#|$)/i.test(url);
  function normalizeTabs(tabs) {
    return (tabs || []).map((t, i) => {
      const firstCta = t?.ctas?.[0] || {};
      const more = t?.testimonial?.more || {};
      const features =
        (t?.featurePills || []).map((p) => ({
          icon: p?.icon?.src || "",
          text: p?.label || "",
        })) || [];

      const media = t?.media || {};
      const rawKind = (media?.kind || "").toLowerCase();
      const imgSrc = media?.image?.src || "";
      const genericSrc = media?.src || "";
      const videoFileSrc = media?.videoFile?.src || "";
      const videoUrlSrc = media?.videoUrl || "";

      let videoKind = "";
      let videoSrc = "";

      if (videoFileSrc || isVideoUrl(genericSrc)) {
        videoKind = "videofile";
        videoSrc = videoFileSrc || genericSrc;
      } else if (videoUrlSrc || rawKind === "videourl") {
        videoKind = "videourl";
        videoSrc = videoUrlSrc || genericSrc;
      } else if (rawKind === "videofile") {
        videoKind = "videofile";
        videoSrc = genericSrc;
      }

      return {
        key: t?.key || `tab-${i}`,
        navLabel: t?.navLabel || `Tab ${i + 1}`,
        heading: t?.headlinePlain || t?.navLabel || `Tab ${i + 1}`,
        features,
        quote: t?.testimonial?.quote || "",
        linkText: more?.label || firstCta?.labelPlain || "View the Demo",
        linkHref: more?.href || firstCta?.href || "#",
        firstCtaLabel: firstCta?.labelPlain || "View the Demo",
        firstCtaHref: firstCta?.href || "#",

        title: t?.navLabel || t?.headlinePlain || `Tab ${i + 1}`,
        img: videoKind ? "" : imgSrc || genericSrc || "",
        videoKind,
        videoSrc,
      };
    });
  }

  const data = rexptWorkFlow?.rexptWorkFlow || rexptWorkFlow;
  const [activeTab, setActiveTab] = useState(0);
  const tabData = normalizeTabs(data.tabs);

  return (
    <div className={styles.tabsWrapper}>
      <div className={styles.TopSection}>
        <div className={styles.LeftBar}>
          <TitleBar blocks={data?.sectionTitle} />
        </div>

        <div className={styles.RightBar}>
          <p className={styles.RightDesc}>
            <PortableText
              value={data.sectionTitleRight}
              components={ptComponents}
            />
          </p>
        </div>
      </div>

      <div className={styles.tabNav}>
        {tabData.map((t, i) => (
          <button
            key={t.key || i}
            className={`${styles.tabButton} ${
              activeTab === i ? styles.active : ""
            }`}
            onClick={() => setActiveTab(i)}
            type="button"
          >
            {t.navLabel || `Tab ${i + 1}`}
          </button>
        ))}
      </div>

      <div className={styles.tabContent}>
        <div className={styles.left}>
          <h2>{tabData[activeTab].heading}</h2>

          <div className={styles.features}>
            {tabData[activeTab].features.map((f, i) => (
              <div key={i} className={styles.featureItem}>
                <span className={styles.icon}>
                  <img src={f.icon} alt="icon" />
                </span>
                <span>{f.text}</span>
              </div>
            ))}
          </div>

          <div className={styles.quotediv}>
            <img src="/Svg/quots-svg.svg" alt="" />
            <p className={styles.quote}>{tabData[activeTab].quote}</p>
          </div>

          <div className={styles.discoverDiv}>
            <a href={tabData[activeTab].linkHref} className={styles.link}>
              {tabData[activeTab].linkText} →
            </a>

            <div className={styles.demoBtn}>
              <a
                href={tabData[activeTab].firstCtaHref}
                aria-label={tabData[activeTab].firstCtaLabel}
              >
                {/* <AnimatedBtn
                  text={tabData[activeTab].firstCtaLabel || "View the Demo"}
                  fontFamily="Arboria Medium"
                /> */}
                <StartNowBtn
                mainText="START NOW"
                subText="Setup in just 3 minutes"
                underline="3 minutes"
                bold=""
              />
              </a>
            </div>
          </div>
        </div>

        <div className={styles.right}>
          {tabData[activeTab].videoKind === "videofile" ? (
            <video
              src={tabData[activeTab].videoSrc}
              autoPlay
              muted
              loop
              controls
              playsInline
              preload="metadata"
              className={styles.video}
            />
          ) : tabData[activeTab].videoKind === "videourl" ? (
            <iframe
              src={tabData[activeTab].videoSrc}
              title={tabData[activeTab].title}
              className={styles.video}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          ) : (
            <img src={tabData[activeTab].img} alt={tabData[activeTab].title} />
          )}
        </div>
      </div>
    </div>
  );
};

export default AutomateTab;
